// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'credit';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.313 2.813H1.688c-.622 0-1.125.503-1.125 1.124v10.126c0 .62.503 1.124 1.125 1.124h14.624c.622 0 1.125-.503 1.125-1.124V3.937c0-.62-.503-1.124-1.125-1.124zM.563 6.188h16.875m-13.5 3.375h6.187m-6.187 2.25h3.937'
  />
);

export const viewBox = '0 0 18 18';
